<script>
  export let file
  export let index
  export let handleRemoveImage
</script>

<style>
  :global(.review-image__wrapper-3Y_Koa) {
    width: 98px;
    height: 98px;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    display: inline-flex;
    padding: 0 2px;
    margin-right: 5px;
    border-radius: 5px;
    z-index: 1;
  }

  :global(.kb-review__image-11kJWn) {
    border-radius: 5px;
    width: 98px;
    height: 98px;
    object-fit: cover;
    margin: auto;
  }

  :global(.close-button-Q7gmQS) {
    position: absolute;
    display: inline-flex;
    align-items: center;
    padding: 8px;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
    transition-duration: 0.2s;
    transition-timing-function: cubic-bezier(0.57, 0.01, 0.04, 1.03);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0);
    text-align: center;
    letter-spacing: -0.1px;
    white-space: nowrap;
    top: 2px;
    right: 2px;
    margin-right: 0 !important;
    margin-left: 8px;
  }

  :global(.close-button-Q7gmQS:hover) {
    background: #e4e8ec;
  }
</style>

<div class="review-image__wrapper-3Y_Koa">
  <div class="close-button-Q7gmQS" on:click={() => handleRemoveImage(index)}>
    <img
      src="https://dashboard2.kudobuzz.com/static/media/icon-close.5b38ea87.svg"
      alt="close-button" />
  </div>
  <img class="kb-review__image-11kJWn" src={file} alt="review" />
</div>
